// extracted by mini-css-extract-plugin
export default {"site_desc":"styles_site_desc__NYEIo","site_desc_point":"styles_site_desc_point__W9ZoS"};